// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.dropdown[data-v-1b7d3aec] {
  width: 100%;
  box-shadow: -1px 0px 5px #bfd3da;
  margin: auto;
  display: block;
  left: 0;
  right: 0;
  border-radius: 0px;
  background: #fff;
}
.dropdown input[data-v-1b7d3aec]:focus {
  outline: none;
  box-shadow: none;
}
.suggestions[data-v-1b7d3aec] {
  padding: 0;
  margin: 0;
  position: absolute;
  bottom: 100%;
  background: #fff;
  width: 100%;
  z-index: 99;
  box-shadow: -3px -3px 5px #bfd3da;
  animation: animated_bottom-1b7d3aec 0.5s;
  transition: 0.5s;
}
ul.suggestions li[data-v-1b7d3aec] {
  list-style: none;
  padding: 8px 20px;
  margin: 0;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.3s
}
ul.suggestions li[data-v-1b7d3aec]:hover {
  background-color: #eee;
}
.dropdown input[data-v-1b7d3aec] {
  width: 100%;
  padding: 12px;
  background: #fff;
  border: 0;
  font-size: 15px;
  font-weight: bold;
}
@keyframes animated_bottom-1b7d3aec {
0% {
    transform: translateY(30px);
}
100% {
    transform: translateY(0px);
}
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatWidget/TvmAutoCompleteAddress/TvmAutoCompleteAddress.vue"],"names":[],"mappings":";AAYA;EACE,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,cAAc;EACd,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;AAIA;EACE,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,wCAA+B;EAC/B,gBAAgB;AAClB;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf;AACF;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;AAEA;AACE;IACE,2BAA2B;AAC7B;AAEA;IACE,0BAA0B;AAC5B;AACF","sourcesContent":["<template>\r\n  <div class=\"dropdown position-relative\">\r\n    <ul v-if=\"suggestions.length\" class=\"suggestions\" :style=\"{ bottom: suggestionBottom }\">\r\n      <li v-for=\"suggestion in suggestions\" :key=\"suggestion.place_id\" @click=\"selectSuggestion(suggestion)\">\r\n        {{ suggestion.description }}\r\n      </li>\r\n    </ul>\r\n\r\n  </div>\r\n</template>\r\n<script src=\"./TvmAutoCompleteAddress.js\"></script>\r\n<style scoped>\r\n.dropdown {\r\n  width: 100%;\r\n  box-shadow: -1px 0px 5px #bfd3da;\r\n  margin: auto;\r\n  display: block;\r\n  left: 0;\r\n  right: 0;\r\n  border-radius: 0px;\r\n  background: #fff;\r\n}\r\n\r\n\r\n\r\n.dropdown input:focus {\r\n  outline: none;\r\n  box-shadow: none;\r\n}\r\n\r\n.suggestions {\r\n  padding: 0;\r\n  margin: 0;\r\n  position: absolute;\r\n  bottom: 100%;\r\n  background: #fff;\r\n  width: 100%;\r\n  z-index: 99;\r\n  box-shadow: -3px -3px 5px #bfd3da;\r\n  animation: animated_bottom 0.5s;\r\n  transition: 0.5s;\r\n}\r\n\r\nul.suggestions li {\r\n  list-style: none;\r\n  padding: 8px 20px;\r\n  margin: 0;\r\n  border-bottom: 1px solid #eee;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s\r\n}\r\n\r\nul.suggestions li:hover {\r\n  background-color: #eee;\r\n}\r\n\r\n.dropdown input {\r\n  width: 100%;\r\n  padding: 12px;\r\n  background: #fff;\r\n  border: 0;\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n}\r\n\r\n@keyframes animated_bottom {\r\n  0% {\r\n    transform: translateY(30px);\r\n  }\r\n\r\n  100% {\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n</style>\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
